import React, { ReactElement, useLayoutEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import { SimpleEditorProps } from 'types/tinymceEditor';

function TinyMCE({
  onChange,
  value,
  name,
  height,
  setLoading,
  toggleFileImage,
  colorScheme,
}: SimpleEditorProps): ReactElement {
  useLayoutEffect(() => {
    setLoading && setLoading(true);
    return () => {
      setLoading && setLoading(false);
    };
  }, [setLoading]);

  const toolbar = `undo redo | blocks | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | image ${toggleFileImage ? '| FileImage' : ''
    } | a11ycheck | formatpainter | permanentpen | checklist | casechange | addcomment showcomments |`;
  return (
    <Editor
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      onInit={() => {
        setLoading && setLoading(false);
      }}
      textareaName={name}
      value={value}
      init={{
        license_key:
          'T8LK:eyJhbGciOiJFUzI1NiIsIng1YyI6WyJNSUlCbURDQ0FUMmdBd0lCQWdJVWJTS2NpUDJROHBNTFJTc29JS29ucUNXYmw1VXdDZ1lJS29aSXpqMEVBd0l3UHpFYU1CZ0dBMVVFQ2d3UlZHbHVlU0JVWldOb2JtOXNiMmRwWlhNeElUQWZCZ05WQkFNTUdGUnBibmxOUTBVZ09DQnNhV05sYm5ObElHdGxlU0JEUVRBZ0Z3MHlOVEEwTVRBd05ESTJNVEJhR0E4eU1EYzFNREV3TVRBME1qWXhNRm93RWpFUU1BNEdBMVVFQXd3SFZEaE1TMU10VURCWk1CTUdCeXFHU000OUFnRUdDQ3FHU000OUF3RUhBMElBQkdnTjlqUG5Ga2o1Q0VSbEJDUkNMNGliOXBDMUo5U3p4ajBmckU1QkgxdE8yaEZYQmlNd2VlRjFheEh6cjBEcnhycUE0dDNFbTJZaUYyekk4ZVFoa2dHalFqQkFNQjBHQTFVZERnUVdCQlE0dU42blREemN1YmlHMXVET3Q4OUlQMkFWQlRBZkJnTlZIU01FR0RBV2dCVHFoanNsN0lWdEZFYVMvaFNSUXhiT2ZuaWFRVEFLQmdncWhrak9QUVFEQWdOSkFEQkdBaUVBMmtHTmVZRnRranYvemFzUEVKWjBQVFZTOW1KdTFaRWYvWklQTGFFSDJ6MENJUURRTnFBL0FFTVFlQno2T0VHNlBteVhFakJVZDVqRDBxcVlwVS9pM1hhL2VRPT0iXX0.CiQwMTljZGVjNy1lZTAwLTcwYWUtYTU1Yi02YTlmODM3YmE4OGHCAhUKDAj_6ZLcBhDAj67cAxIFCICangGwBAjSBR0CAwQFFgcICQoLDg8jERIUFRcYGRofHB0eIBIfHg.wjJpJHunVUTQI2lYbFLKDBqPayvuiIy2cHOfOGF8Q48nr0g2x-tLSpTuu64_ju3xx2PifBEp0VfgWqyPxXlszw',
        skin: colorScheme == 'dark' ? 'oxide-dark' : 'oxide',
        autolink_pattern:
          /^(https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/|www\.)(.+)$/i,
        height: height || 500,
        menubar: false,
        plugins: [
          'link',
          'searchreplace visualblocks',
          'paste',
          'image',
          'a11ychecker',
          'formatpainter',
          'permanentpen',
          'checklist',
          'casechange',
          'tinycomments',
          'lists',
          'spellchecker',
          'tinymcespellchecker',
        ],
        tinycomments_mode: 'embedded',
        tinycomments_author: 'Author',
        toolbar: toolbar,
        link_title: false,
        spellchecker_active: true,
        forced_root_block_attrs: {
          style: 'margin: 0',
        },
        setup: editor => {
          if (toggleFileImage)
            editor.ui.registry.addButton('FileImage', {
              icon: undefined,
              tooltip: 'File/Image',
              text: 'File/Image',
              onAction: function () {
                toggleFileImage && toggleFileImage();
              },
            });
        },
      }}
      onEditorChange={onChange}
      key={colorScheme}
    />
  );
}

export { TinyMCE };
